import { render, staticRenderFns } from "./Unions.vue?vue&type=template&id=774475ae&"
import script from "./Unions.vue?vue&type=script&lang=js&"
export * from "./Unions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports